import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { checkoutUrl } from '../data/offer';
import { handleCheckoutClick } from './CtaButton';

/** Fixed checkout bar for phones, revealed once the hero is out of view. */
export function MobileCheckoutBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 520);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-143" data-mp="ixrslvhqgtbs">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-gold/30 bg-night-deep/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur md:hidden" data-id="element-144" data-mp="iwzy6nzvh1n3">
          <div className="flex items-center gap-3" data-id="element-145" data-mp="336xhn4uv1ru6">
            <div className="shrink-0" data-id="element-146" data-mp="2y7b0ikbwvrg3">
              <p className="flex items-baseline gap-1.5" data-id="element-147" data-mp="2y8cofpe108f8">
                <span className="font-display text-2xl leading-none text-gold" data-id="element-148" data-mp="3d424l6wj5rc1">$27</span>
                <span className="text-xs font-medium text-cream-muted line-through" data-id="element-149" data-mp="3858nz5ly5k7n">$745</span>
              </p>
              <p className="mt-0.5 text-[10px] font-semibold uppercase tracking-[0.1em] text-cream-muted" data-id="element-150" data-mp="3m4qj02pu5tpg">
                Ends tonight
              </p>
            </div>
            <a href={checkoutUrl} rel="noopener" onClick={() => handleCheckoutClick('mobile_sticky_bar')} className="flex flex-1 items-center justify-center rounded-full bg-gold px-4 py-3.5 text-xs font-semibold uppercase tracking-[0.06em] text-night transition-colors duration-150 ease-expo active:bg-gold-dark" data-id="element-151" data-mp="3h3ucdhe3ntgc">
              Get the bundle
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}